import React from 'react';

const style = {"background": "transparent",
          "paddingBottom": "15px"
          }
export default function Footer() {
  return (
    <footer className="fixed-footer" style={style}></footer>
  )
}



// WEBPACK FOOTER //
// ./src/components/footer.js